// Default production API host.
//
// Points at the 24/7 Node daemon behind the Cloudflare Tunnel
// (org.nonarkara.yala-api). This is the ONLY backend that carries the live data:
// it runs on plain Node so it can reach Thai-government endpoints that workerd's
// TLS rejects, and it holds the API keys (FRED, AQICN, …) in its env. The old
// `*.drnon.workers.dev` Worker is keyless + can't reach those feeds, so it is
// retired to the legacy set below. Override with `VITE_API_BASE_URL` at build time.
const YALA_API_BASE = "https://yala-api.nonarkara.org";
const LEGACY_API_HOSTS = new Set([
  "https://chula-api.nonarkara.org",
  "http://chula-api.nonarkara.org",
  // Hosts that resolved nowhere / served no live data — treat as legacy so any
  // stale build-time env var still routes through the working tunnel host.
  "https://yala-control-tower-api.drnon.workers.dev",
  "https://chonburi-api.nonarkara.org",
  "https://chonburi-control-tower-api.drnon.workers.dev",
]);

function normalizeBase(raw: string | undefined): string {
  return (raw ?? "").trim().replace(/\/+$/, "");
}

export function resolveApiBase(raw: string | undefined = import.meta.env.VITE_API_BASE_URL): string {
  const base = normalizeBase(raw);
  const isLegacy = LEGACY_API_HOSTS.has(base);

  if (import.meta.env.DEV && (!base || isLegacy)) {
    return "";
  }

  if (!base || isLegacy) {
    return YALA_API_BASE;
  }

  return base;
}

export const API_BASE = resolveApiBase();
